//
//
//
//
//
//
export default {
  name: 'CoreDtwinMapOverlayWizardImageAnchorMarker',
  props: {
    position: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      dragging: {
        start: null
      }
    };
  },
  watch: {
    position: function position() {
      if (this.position.x && this.position.y) {
        this.$refs.marker.$el.style.left = "".concat(this.position.x, "px");
        this.$refs.marker.$el.style.top = "".concat(this.position.y, "px");
      }
    }
  },
  mounted: function mounted() {
    this.$refs.marker.$el.style.left = "".concat(this.position.x, "px");
    this.$refs.marker.$el.style.top = "".concat(this.position.y, "px");
  },
  methods: {
    onDragStart: function onDragStart(e) {
      e = e || window.event;
      e.preventDefault();
      this.dragging.start = {
        x: e.clientX,
        y: e.clientY
      };
      document.onmouseup = this.onDragEnd;
      document.onmousemove = this.onDrag;
    },
    onDrag: function onDrag(e) {
      if (this.dragging.start === null) {
        return;
      }

      e = e || window.event;
      e.preventDefault();
      var x = this.dragging.start.x - e.clientX;
      var y = this.dragging.start.y - e.clientY;
      this.dragging.start = {
        x: e.clientX,
        y: e.clientY
      };
      this.$emit('moved-anchor', {
        offsetX: -x,
        offsetY: -y
      });
    },
    onDragEnd: function onDragEnd(e) {
      if (this.dragging.start === null) {
        return;
      }

      document.onmouseup = null;
      document.onmousemove = null;
      e = e || window.event;
      var x = this.dragging.start.x - e.clientX;
      var y = this.dragging.start.y - e.clientY;
      this.dragging.start = null;
      this.$emit('moved-anchor', {
        offsetX: -x,
        offsetY: -y
      });
    }
  }
};